export const Dim = ({ children }) => <span className="text-neutral-500">{children}</span>;
export const White = ({ children }) => <span className="text-neutral-100">{children}</span>;
export const Blue = ({ children }) => <span className="text-sky-400">{children}</span>;
export const Green = ({ children }) => <span className="text-emerald-400">{children}</span>;
export const Yellow = ({ children }) => <span className="text-amber-400">{children}</span>;

export const Heading = ({ children }) => (
  <div className="mt-1 mb-2 text-neutral-100 font-semibold tracking-wide">{children}</div>
);

export const Row = ({ label, children }) => (
  <div className="flex gap-3">
    <span className="text-neutral-500 w-24 shrink-0">{label}</span>
    <span className="text-neutral-200">{children}</span>
  </div>
);

export const StatusTag = ({ status }) => {
  const map = {
    LIVE: "text-emerald-400",
    SHIPPED: "text-emerald-400",
    WIP: "text-amber-400",
    ARCHIVED: "text-neutral-500",
  };
  return <span className={map[status] || "text-neutral-400"}>[{status}]</span>;
};